import React, { useEffect, useState } from "react";
import "../../assets/css/Footer.css";
import logo from "../../assets/images/logo.png";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import arrowupfooter from "../../assets/images/arrowup-footer.png";
import icon_facebook from "../../assets/images/footer-facebook.png";
import icon_youtube from "../../assets/images/footer-youtube.png";
import icon_insta from "../../assets/images/footer-insta.png";
import icon_twitter from "../../assets/images/footer-twitter.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSiteMapApi, newsLetteApi } from "../../Redux/Auth/Auth_Action";
import { toast } from "react-toastify";

const Footer = () => {
	const [newsletter, setState] = useState("");
	const [siteMap, setSiteMap] = useState();
	const [siteSetting, setSiteSetting] = useState(null);

	let navigate = useNavigate();
	const dispatch = useDispatch();
	const ReduxToken = useSelector((state) => state.Auth.token);
	const SentNewsLetter = (e) => {
		e.preventDefault();
		if (!newsletter) {
			return toast.error("please fill out this field");
		}
		let data = {
			email: newsletter,
		};
		dispatch(newsLetteApi(data, ReduxToken))
			.then((res) => {
				toast.success("You have successfully subscribed to our Newsletter");
				setState("");
				window.scroll(0, 0);
			})
			.catch((e) => {
				console.log("error from footer", e);
			});
	};

	const FuncgetSiteMap = () => {
		dispatch(getSiteMapApi())
			.then((res) => {
				setSiteMap(res?.data?.response?.data);
				// console.log(res, 'zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz');
			})
			.catch((e) => {
				console.log(e, "rrrrrrrrrrrrrrrrrrrrrrrrrrrrrr");
			});
	};

	useEffect(() => {
		FuncgetSiteMap();
		setTimeout(() => {
			if (localStorage.getItem("siteSettings")) {
				setSiteSetting(JSON.parse(localStorage.getItem("siteSettings")));
			}
		}, 1500);
	}, []);

	// console.log(siteSetting, 'from footer consoleeeeeeeeeeeeeee');

	return (
		<div className="footer">
			<div className="container">
				<div className="row">
					<div className="col-lg-12 text-center">
						<img
							onClick={() => {
								navigate("/");
							}}
							src={logo}
							className="footer_logo my-4"
							alt="logo_footer"
						/>
					</div>
				</div>
			</div>
			<div className="border-logo-btm-footer mb-3"></div>
			<div className="container py-3">
				<div className="row">
					<div className="col-lg-6 pr-5">
						<div className="row">
							<div className="col-lg-7">
								<p className="f-mon-reg f-16 text-white mt-5">Newsletter</p>
								<p className="f-mon-light f-14 clr-a1">
									Get the latest news and updates on all the games and bets.
								</p>
								<form onSubmit={SentNewsLetter}>
									<div className="d-flex">
										<input
											name="newsletter"
											value={newsletter || ""}
											onChange={(e) => {
												setState(e.target.value);
											}}
											type="email"
											className="p-2 form-control rounded-0 bg-trans-footer border-right-0"
										/>
										<button
											type="submit"
											className="btn btn-light rounded-0 border-0 bt-footer-submit f-mon-med f-14 text-white"
										>
											Submit
										</button>
									</div>
								</form>
							</div>
							<div className="col-lg-5 res-set">
								<p className="f-mon-reg f-16 text-white mt-5">MENU</p>
								<p
									onClick={() => {
										navigate("/");
									}}
									className="mb-0 f-mon-reg f-16 text-white cursor_pointer txt-underline"
								>
									Home
								</p>
								<p
									onClick={() => {
										navigate("/aboutus");
									}}
									className="mb-0 f-mon-reg f-16 text-white cursor_pointer txt-underline"
								>
									About Me
								</p>
								<p
									onClick={() => {
										navigate("/tips");
									}}
									className="mb-0 f-mon-reg f-16 text-white cursor_pointer txt-underline"
								>
									Tips
								</p>
								<p
									onClick={() => {
										navigate("/packages");
									}}
									className="mb-0 f-mon-reg f-16 text-white cursor_pointer txt-underline"
								>
									Packages
								</p>
							</div>
						</div>
					</div>
					<div className="col-lg-6 pl-5 pl-ressz">
						<div className="row">
							<div className="col-lg-5">
								<p className="f-mon-reg f-16 text-white mt-5">OTHER PAGES</p>
								<p
									onClick={() => {
										navigate("/blogs");
									}}
									className="mb-0 text-white f-mon-reg f-16 cursor_pointer txt-underline"
								>
									Blogs
								</p>
								<p
									onClick={() => {
										navigate("/contactus");
									}}
									className="mb-0 text-white f-mon-reg f-16 cursor_pointer txt-underline"
								>
									Contact
								</p>
								<p
									onClick={() => {
										navigate("/podcast");
									}}
									className="mb-0 text-white f-mon-reg f-16 cursor_pointer txt-underline"
								>
									Podcast
								</p>
								<a
									href={`${siteMap?.link}`}
									className="mb-0 text-white f-mon-reg f-16 cursor_pointer txt-underline"
								>
									Site Map
								</a>
							</div>
							<div className="col-lg-7 text-left">
								<p className="f-mon-reg f-16 text-white mt-5 mb-3">
									CONTACT US
								</p>
								<a
									className="mb-0 clr-white-light f-mon-reg f-13 txt-noundrline  mb-2"
									href="tel:+423-315-2860"
								>
									<p className="mb-0 clr-white-light  f-mon-reg f-13  mb-2 txt-underline">
										<PhoneInTalkOutlinedIcon />
										{/* 423-315-2860 */}
										{siteSetting?.[0]?.contact_phone}
									</p>
								</a>
								<a
									className="mb-0 clr-white-light f-mon-reg f-13 txt-noundrline  mb-2"
									href="mailto:predictiondog@gmail.com"
								>
									<p className="mb-0 clr-white-light f-mon-reg f-13  mb-2 txt-underline">
										<MailOutlinedIcon className="mr-1" />
										{/* Email: predictiondog@gmail.com */}
										{siteSetting?.[0]?.contact_email}
									</p>
								</a>
								<p className="mb-0 clr-white-light f-mon-reg f-13  ">
									<LocationOnOutlinedIcon />
									{/* 79 College Road,Harrow,HA1 1BD */}
									{siteSetting?.[0].address}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="d-flex jsutify-space-btwn my-4">
					<div className="border-logo-btm-footer mb-3"></div>

					<img
						onClick={() => {
							window.scrollTo(0, 0);
						}}
						src={arrowupfooter}
						className="mx-5 img_footer_top"
					/>

					<div className="border-logo-btm-footer mb-3"></div>
				</div>
				<div className="row mt-4">
					<div className="col-lg-4 mt-2 mb-4">
						<p className="f-pop-med f-14 text-white copyRight">
							© <Link to="/">Prediction Dog</Link>{" "}
							{siteSetting?.[0]?.footer_sentence}
						</p>
					</div>
					<div className="col-lg-4 mt-2 mb-4 text-center">
						<a href={`${siteSetting?.[0]?.facebook}`} target="_blank">
							<img src={icon_facebook} className="mx-2" alt="icon-footer" />
						</a>
						<a href={`${siteSetting?.[0]?.youtube}`} target="_blank">
							<img src={icon_youtube} className="mx-2" alt="icon-footer" />
						</a>
						<a href={`${siteSetting?.[0]?.instagram}`} target="_blank">
							<img src={icon_insta} className="mx-2" alt="icon-footer" />
						</a>
						<a href={`${siteSetting?.[0]?.twitter}`} target="_blank">
							<img
								src={icon_twitter}
								className="mx-2 cursor_pointer"
								alt="icon-footer"
							/>
						</a>
					</div>
					<div className="col-lg-4 mt-2 mb-4 text-right res-set">
						<span
							onClick={() => {
								navigate("/privacypolicy");
							}}
							className="f-pop-med f-16 clr-white-light cursor_pointer txt-underline"
						>
							Privacy Policy{" "}
						</span>
						<span className="mx-2 f-pop-med f-16 clr-white-light">|</span>
						<span
							onClick={() => {
								navigate("/termsandcondition");
							}}
							className="f-pop-med f-16 clr-white-light cursor_pointer txt-underline"
						>
							Terms & condiotion
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
